import React, { useContext } from "react";
import "./CenterModel.scss";
import { Modal } from "react-bootstrap";
import DarkModeContext from "../../../utils/Context/DarkModeContext";
import Iconify from "../../../layouts/components/iconify/iconify";

const CenterModel = ({
  showModal,
  handleToggleModal,
  children,
  className,
  backdropClosable = false, // Control backdrop click behavior
  ...props
}) => {
  const { isDarkMode } = useContext(DarkModeContext);

  return (
    <Modal
      className={`center-model-popup ${props.modelSizeClass} ${className} ${
        isDarkMode ? "dark-mode" : ""
      }`}
      show={showModal}
      onHide={handleToggleModal}
      backdrop={backdropClosable ? " " : "static"} // Control backdrop click
    >
      <Modal.Header>
        <div className="model-title">{props.modalTitle}</div>
        <button className="btn-close-custom" onClick={handleToggleModal}>
          <Iconify icon="mingcute:close-line" width="24" height="24" />
        </button>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default CenterModel;
